import React from "react";
import { useTranslation } from "react-i18next";
import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { KeywordReviewCrossAnalysisLocationData } from "../../../types/keywordReviewCrossAnalysisData";

import "./styles.scss";

interface ISatisfactionRatioScatterplotProps {
  locationData: KeywordReviewCrossAnalysisLocationData;
}

const SatisfactionRatioScatterplot: React.FunctionComponent<
  ISatisfactionRatioScatterplotProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`EXPERIMENTAL_organizationFeaturesPage.${key}`);
  const { locationData } = props;

  const data = locationData.keywords.map((keyword) => ({
    keyword: keyword.keyword,
    reviews_count: keyword.reviews_count,
    keyword_value: keyword.keyword_value,
  }));

  return (
    <div className="satisfaction-ratio-scatterplot">
      <ResponsiveContainer>
        <ScatterChart {...{ overflow: "visible" }}>
          <defs>
            <linearGradient id="gradient" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stopColor="#96001B" />
              <stop offset="40%" stopColor="white" />
              <stop offset="60%" stopColor="white" />
              <stop offset="100%" stopColor="#7AC63F" />
            </linearGradient>
          </defs>
          <CartesianGrid fill={"url(#gradient)"} strokeDasharray="3 3" />
          <XAxis
            type="number"
            dataKey="reviews_count"
            name={t("breakdown_list.reviews_count")}
            tick={{ fontSize: 13 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("breakdown_list.reviews_count"),
              style: { fontFamily: "Inter" },
              position: "bottom",
            }}
          />
          <YAxis
            type="number"
            dataKey="keyword_value"
            name={t("breakdown_list.keyword_value")}
            tick={{ fontSize: 13 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("breakdown_list.keyword_value"),
              angle: -90,
              position: "left",
              style: { fontFamily: "Inter" },
            }}
          />
          <Tooltip
            content={({ payload }) => {
              const data = payload?.[0]?.payload;
              return (
                <div className="satisfaction-ratio-scatterplot-tooltip">
                  <span>{data?.keyword}</span>
                  <span>
                    {t("breakdown_list.keyword_value")}:{" "}
                    {new Intl.NumberFormat("en").format(data?.keyword_value)}
                  </span>
                  <span>
                    {t("breakdown_list.reviews_count")}:{" "}
                    {new Intl.NumberFormat("en").format(data?.reviews_count)}
                  </span>
                </div>
              );
            }}
            formatter={(value) =>
              new Intl.NumberFormat("en").format(value as number)
            }
          />
          <Scatter data={data} />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SatisfactionRatioScatterplot;
